import { render, staticRenderFns } from "./AdminCopperCate2.vue?vue&type=template&id=0fd71599&scoped=true&"
import script from "./AdminCopperCate2.vue?vue&type=script&lang=js&"
export * from "./AdminCopperCate2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd71599",
  null
  
)

export default component.exports